export default {
	getRoomDetailsForId: state => id => {
		return state.roomDetailsById[id] ? state.roomDetailsById[id] : null;
	},
	getAssetCategoryForId: state => id => {
		return state.assetCategory.find(a => a.id === id);
	},
	getAssetGroupForId: state => id => {
		return state.assetGroup.find(a => a.id === id);
	},
	getAssetForId: state => id => {
		return state.asset.find(a => a.id === id);
	},
	getLocationForId: state => id => {
		return state.locations.find(a => a.id === id);
	},
	getHTMLWidgetForId: state => id => {
		const widget = state.HTMLWidget.find(a => a.id === id);
		return widget ? widget.html : null;
	},
	userClassGetLocationForId: state => id => {
		return state.userClassLocations.find(
			l => parseInt(l.id) === parseInt(id)
		);
	},
	getOpeningHoursForLocationOnDate: state => (location, date) => {
		if (state.openingHoursForDate[date]) {
			return state.openingHoursForDate[date].find(
				l => parseInt(l.id) === parseInt(location)
			);
		}
		return null;
	},
	getMaxOpeningHoursForLocationsOnDate: state => (locations, date) => {
		if (state.openingHoursForDate[date] && locations.length > 0) {
			return (
				state.openingHoursForDate[date]
					.filter(l => locations.indexOf(l.id.toString()) !== -1)
					//filter out closed locations
					.filter(l => l.open !== l.close)
					.reduce(
						(ret, loc) => {
							if (ret.open === null) {
								ret.open = loc.open;
							} else if (loc.open < ret.open) {
								ret.open = loc.open;
							}
							if (ret.close === null) {
								ret.close = loc.close;
							} else if (loc.close > ret.close) {
								ret.close = loc.close;
							}
							return ret;
						},
						{ open: null, close: null }
					)
			);
		}
		return null;
	}
};
